import { render, staticRenderFns } from "./FTP.vue?vue&type=template&id=20234aab&"
import script from "./FTP.vue?vue&type=script&lang=js&"
export * from "./FTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports